import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { ShieldAlert, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function NewDeviceBanner() {
  const [devices, setDevices] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/auth/devices").then((r) => setDevices(r.data.new_devices || [])).catch(() => setDevices([])); }, []);
  if (!devices.length) return null;
  const d = devices[0];
  const dismiss = async () => { setDevices([]); await api.post("/auth/devices/ack").catch(() => {}); };
  const signOutAll = async () => {
    setBusy(true);
    try { await api.post("/auth/logout-all"); toast.success("Signed out everywhere — only this device stays signed in"); setDevices([]); }
    catch { toast.error("Could not sign out other devices"); } finally { setBusy(false); }
  };
  return (
    <div className="mb-6 p-4 rounded-2xl bg-amber-500/10 border border-amber-400/40 flex flex-wrap items-center gap-3 rise" data-testid="new-device-banner">
      <ShieldAlert className="w-5 h-5 text-amber-300 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <p className="font-semibold text-sm text-amber-100">New device signed in to your account</p>
        <p className="text-xs text-amber-200/70" data-testid="new-device-detail">{d.ua?.length > 60 ? `${d.ua.slice(0, 60)}…` : d.ua} · IP {d.ip} · {new Date(d.first_seen).toLocaleString()}{devices.length > 1 ? ` · +${devices.length - 1} more` : ""}</p>
      </div>
      <Button size="sm" onClick={signOutAll} disabled={busy} className="bg-amber-400 text-slate-950 hover:bg-amber-300 font-semibold" data-testid="sign-out-everywhere-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Wasn't me — sign out everywhere"}</Button>
      <button onClick={dismiss} className="text-amber-200/70 hover:text-amber-100" aria-label="Dismiss" data-testid="new-device-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
